
import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';

const ForgotPassword: React.FC<{ onResetComplete: () => void }> = ({ onResetComplete }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const auth = getAuth();

  const handlePasswordReset = async () => {
    try {
      setError(null);
      setMessage(null);
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent!');
      setTimeout(onResetComplete, 3000); // Redirect after 3 seconds
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-r from-purple-400 to-indigo-500">
      <div className="p-6 max-w-md bg-white rounded-lg shadow-lg">
        <h2 className="text-xl font-bold text-center mb-4">Forgot Password</h2>
        {message && <p className="text-green-500 text-sm mb-4">{message}</p>}
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        <input
          type="email"
          placeholder="Email"
          className="block w-full p-2 mb-4 border rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          onClick={handlePasswordReset}
          className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700"
        >
          Send Reset Email
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
